export default {"src":"/_next/static/media/icon-back.cb86324a.svg","height":28,"width":28};